import React, { FC, memo } from 'react';
import { ReactComponent as EmptySvg } from 'assets/emptyNoti.svg';
import NotificationItem from './NotificationItem';
import css from './styles.module.scss'
import { IFormattedNotification } from './types';

interface ContentProps {
  notifications: IFormattedNotification[];
  markAsRead: (id: number) => void;
  emptyText: string;
  markAsReadAndRemove: (id: number) => void;
  handleGetTask: (task_id: number) => void;
}

const NotificationsContent: FC<ContentProps> = ({
  notifications,
  markAsRead,
  emptyText,
  markAsReadAndRemove,
  handleGetTask
}) => {
  if (!notifications.length) {
    return (
      <div className={css.empty}>
        <EmptySvg />
        <span>{emptyText}</span>
      </div>
    );
  }

  return (
    <div className={css.notification__grid}>
      {notifications.map((item) => (
        <NotificationItem
          key={item.notification_id}
          notification={item}
          markAsRead={markAsRead}
          markAsReadAndRemove={markAsReadAndRemove}
          handleGetTask={handleGetTask}
        />
      ))}
    </div>
  );
};

export default memo(NotificationsContent);